import {ReactNode} from 'react';
import clsx from 'clsx';
import Pagination from './Pagination';
import RicohBanner from './RicohBanner';

type Size = '2xl' | '3xl' | '4xl' | '5xl' | '6xl';
const sizes: Record<Size, string> = {
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
};
type DualPageProps = {
    children: [ReactNode, ReactNode];
    classNameFirstSection?: string;
    classNameHeader?: string;
    classNameInner?: string;
    classNameOuter?: string;
    classNameSecondSection?: string;
    pagination: {
        current: number;
        length: number;
    };
    size?: Size;
};

const DualPage = ({
    children,
    classNameFirstSection,
    classNameHeader,
    classNameInner,
    classNameOuter,
    classNameSecondSection,
    pagination: {current, length},
    size,
}: DualPageProps) => (
    <div
        className={clsx(
            'flex flex-1 flex-col items-center p-8',
            classNameOuter,
        )}
    >
        <div className={size && sizes[size]}>
            <div className={clsx('mb-1 flex h-16', classNameHeader)}>
                <Pagination current={current} length={length} />
                <RicohBanner />
            </div>
            <div
                className={clsx(
                    'mt-2 grid w-full md:grid-cols-2',
                    classNameInner,
                )}
            >
                <div
                    className={clsx(
                        'relative columns-1',
                        classNameFirstSection,
                    )}
                >
                    {children[0]}
                </div>
                <div
                    className={clsx(
                        'relative columns-1',
                        classNameSecondSection,
                    )}
                >
                    {children[1]}
                </div>
            </div>
        </div>
    </div>
);

export default DualPage;
